import styled from "@emotion/styled";
import { useNavigate } from "@tanstack/react-router";
import { Flex } from "styles/utility-components";

import { LoadingState } from "components/app_layout/LoadingState";
import Button from "../../ui/button/Button";

type Props = {
  title: string;
  description: string;
  bidId: string;
};

export default function BidReportLoadingState({ title, description, bidId }: Props) {
  const navigate = useNavigate();
  return (
    <Container>
      <LoadingState
        title={title}
        description={description}
        actionNode={
          <Button buttonType="secondary" onClick={() => navigate({ to: `/bids/${bidId}` })}>
            Back to Bid
          </Button>
        }
      />
    </Container>
  );
}

const Container = styled(Flex)({
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  height: "100%",
});
